<template>
  <div class="modal fade" tabindex="-1" id="pendingModal" aria-labelledby="pendingModalLabel" aria-hidden="true"
       data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5 text-center">Pendências</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  @click="hideModalPending"></button>
        </div>
        <div class="modal-body">
          <p class="text-black-50">
            Identificamos que um laudo não foi assinado ao término da jornada. <b>Por favor, resolva essa pendência imediatamente.</b> Clique no botão abaixo para verificar e concluir a assinatura.
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="hideModalPending">Fechar janela </button>
          <button class="btn btn-success" :disabled="isButtonAtenderDisabled" @click="openHistory(reportUnsigned)" data-bs-dismiss="modal">
            Resolver
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import 'vue-advanced-cropper/dist/style.css';
export default {  
  props: {
    reportUnsigned: Object,
    visibleModalPendency: Boolean,
  },  
  data() {
    return {   
      isButtonResolve: false,   
    };
  },
  methods: {
    ...mapActions(["GetReportById"]),
    closeModalPendency() {
      this.$emit("close");
    },
    async openHistory(reportUnsigned) {
      try {
        this.isButtonResolve = true;
        await this.GetReportById(reportUnsigned.id);
        this.$router.push({ name: 'HistoricalReview' });       
      }
      catch (erro) {        
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });        
      }
    },
    hideModalPending() {
      this.$emit("hideModalPending")
    },
  },
};
</script>

<style>

</style>
